import InstructorAdvanceSearch from "./InstructorAdvanceSearch";
export default InstructorAdvanceSearch;
